export const MOVEMENT_TYPES = {
	1: "Aplicación",
	2: "Traspaso",
	3: "Nota de Crédito",
	4: "Robo",
	5: "Otro",
};

export const getMovementTypeLabel = (typeId) => {
	return MOVEMENT_TYPES[typeId] || "Desconocido";
};

export const getMovementTypeVariant = (typeId) => {
	switch (typeId) {
		case 1:
			return "success";
		case 2:
			return "warning";
		case 3:
			return "info";
		case 4:
			return "dark";
		case 5:
			return "danger";
		default:
			return "neutral";
	}
};
